import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import sculptureImg from '../../assets/images/heritage/sculpture.jpg'

const FinalCTASection = () => (
  <section className="relative w-full h-[55vh] min-h-[460px] max-h-[620px] overflow-hidden">
    <img src={sculptureImg} alt="Temple sculpture, Pattadakal, Karnataka" className="absolute inset-0 w-full h-full object-cover" />
    <div className="absolute inset-0 bg-museum-black/78" />

    <div className="relative z-10 h-full flex items-center justify-center text-center px-6">
      <motion.div
        className="max-w-2xl"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <p className="text-[10px] uppercase tracking-[0.35em] text-museum-antique-gold font-sans font-semibold mb-7">
          05 &mdash; Begin
        </p>
        <h2
          className="font-editorial italic font-normal text-museum-ivory leading-[0.95] mb-9"
          style={{ fontSize: 'clamp(2rem, 4.6vw, 3.4rem)' }}
        >
          Your collection deserves
          <br />
          to be remembered.
        </h2>
        <Link to="/signup">
          <button className="inline-flex items-center gap-3 px-10 py-4 border border-museum-antique-gold/70 text-museum-ivory font-sans font-medium text-[11px] uppercase tracking-[0.24em] hover:bg-museum-antique-gold hover:text-museum-black hover:border-museum-antique-gold transition-colors duration-500">
            Start Your Archive
            <ArrowRight size={15} />
          </button>
        </Link>
      </motion.div>
    </div>
  </section>
)

export default FinalCTASection
